<template>
  <footer class="full box dark-back section-padding center-text">
    <div class="footer-brand half">
      <img :src="logo" class="footer-logo third" alt="BGS Logo" />
      <social-media type="clear"></social-media>
      <!-- <language-picker></language-picker> -->
    </div>
    <div class="footer-links half">
      <footer-title class="clear" sub="Para mayor información">Enlances de Interés</footer-title>
      <interest-links size="half"></interest-links>
    </div>
    <p class="copyrights">© 2020, Powered by Torreta Corp</p>
  </footer>
</template>

<script>
import SocialMedia from '@/components/SocialMedia.vue';
import FooterTitle from '@/components/SectionTitle.vue';
import InterestLinks from '@/components/LinksInterest.vue';
// import LanguagePicker from '@/components/LanguagePicker.vue';

import Logo from '@/assets/images/logo.png';

export default {
  name: 'TheFooter',
  components: {
    FooterTitle,
    SocialMedia,
    InterestLinks,
    // LanguagePicker,
  },
  data() {
    return {
      logo: Logo,
    };
  },
};
</script>

<style lang="scss" scoped>
footer {
  .footer-brand {
  }

  .footer-links {
  }

  p.copyrights {
    font-family: Georgia, "Times New Roman", Times, serif;
    font-size: 1.25em;
    font-weight: lighter;
    font-variant: normal;
    color: #fff;
  }
}

@media screen and (max-width: 900px) {
  footer {
    .footer-brand {
      .footer-logo {
        width: 50%;
      }
    }

    .footer-links {
    }
  }
}

@media screen and (max-width: 600px) {
  footer {
    .footer-brand {
      width: 100%;
      order: 2;
    }

    .footer-links {
      width: 100%;
      order: 1;
    }

    .copyrights {
      order: 3;
    }
  }
}
</style>
